import { ItemData } from 'core/models/Template'

export const SUBJECTS_CATALOG_TYPE = 'subjects' as const

export const SUBJECTS_CATALOG_CONFIG = {
    type: SUBJECTS_CATALOG_TYPE,
    fixedHeader: true,
    isExistRightToolbar: false,
    treeView: false,
} as const

export type SubjectsSelectedItems = ItemData[]

export type SubjectsCatalogOption = {
    id: number
    title: string
}

export type SubjectsAdditionalData = {
    grades: SubjectsCatalogOption[]
    courses: SubjectsCatalogOption[]
}
